// Gate decorative hover by the actual pointer, including on hybrid devices.
module.exports = function initInputMode(doc, win) {
	var root = doc.documentElement;
	function setMode(mode) {
		if (root.getAttribute('data-hover') !== mode) {
			root.setAttribute('data-hover', mode);
		}
	}
	function onPointer(event) {
		if (event.pointerType === 'mouse') setMode('mouse');
		else if (event.pointerType === 'touch' || event.pointerType === 'pen') setMode('touch');
	}
	setMode(win.matchMedia('(hover: hover) and (pointer: fine)').matches ? 'mouse' : 'touch');
	['pointerover', 'pointerdown', 'pointermove'].forEach(function(type) {
		doc.addEventListener(type, onPointer, { capture: true, passive: true });
	});
	doc.addEventListener('touchstart', function() { setMode('touch'); }, { capture: true, passive: true });
};
